/*global jQuery:false */
'use strict';

const FindStoreHelper = function () {
    const _bindFindStore = function (fsSliderContainerId) {
        const fsProvinceContainer = fsSliderContainerId + ' .fs--province-container'
        const fsCityContainer = fsSliderContainerId + ' .fs--city-container';
        const fsSearchProvince = fsSliderContainerId + ' .fs-search-province';
        const fsFindButton = fsSliderContainerId + ' .find-btn';
        const fsPostalCode = fsSliderContainerId + ' #postalCode';
        const fsProvinceHidden = fsSliderContainerId + ' .province-hidden';
        const fsCityHidden = fsSliderContainerId + ' .city-hidden';
        const fsSearchProvinceButton = fsSliderContainerId + ' .fs--btn-search-province';
        const fsSearchCityButton = fsSliderContainerId + ' .fs--btn-search-city';
        const fsCityItems = fsSliderContainerId + ' .fs--city-items';
        const fsProvinceItems = fsSliderContainerId + ' .fs--province-items';
        const fsOpenCity = fsSliderContainerId + ' .openCity';
        const fsOpenProvince = fsSliderContainerId + ' .openProvince';

        let subPerProvince = document.querySelectorAll(fsProvinceContainer);
        let subPerCity = document.querySelectorAll(fsCityContainer);
        $('.ss--header .modal__close.focusable').focus();

        // On click, Open view number of items per page
        $(fsOpenProvince).bind('click', function (e) {
            if ($(fsOpenCity).hasClass('active')) {
                $(fsOpenCity).trigger('click');
            }
            $(this).toggleClass('active');
            if ($(this).attr('aria-expanded') == 'false') {
                $(this).attr('aria-expanded', 'true');
            } else {
                $(this).attr('aria-expanded', 'false');
            }
            jQuery(subPerProvince).slideToggle('fast');
            e.preventDefault();
        });

        $(fsOpenCity).bind('click', function (e) {
            if ($(fsOpenProvince).hasClass('active')) {
                $(fsOpenProvince).trigger('click');
            }
            $(this).toggleClass('active');
            if ($(this).attr('aria-expanded') == 'false') {
                $(this).attr('aria-expanded', 'true');
            } else {
                $(this).attr('aria-expanded', 'false');
            }
            jQuery(subPerCity).slideToggle('fast');
            e.preventDefault()
        });

        $(fsSearchProvince + ' li a[href=#]').click(function (e) {
            e.preventDefault();
            let provinceCode = $(this).attr('data-filter');
            let provinceName = $(this).text();

            $(fsPostalCode).val('');
            $(fsProvinceHidden).val(provinceCode);
            $(fsSearchProvinceButton).text(provinceName);
            $(fsSearchCityButton).text(/*[[#{findstore.province.selectcity.text}]]*/);
            let imgIcon = $("<img src=\"/images/main/actions/toggle-down.svg\" alt=\"\" />");
            $(fsSearchProvinceButton).append(imgIcon);

            let obj = $.parseJSON(topAllCities);
            let mySelected = provinceCode == 'QC' ? obj.QC : obj.ON;

            $(fsCityItems).empty();
            $.each(mySelected, function (i, item) {
                let li = $("<li><a></a></li>");
                $(fsCityItems).append(li);
                $("a", li).text(item);
                $("a", li).attr("href", '#');
            });

            let objProvCities = $.parseJSON(provinceCities);
            let selectedProvCities = provinceCode == 'QC' ? objProvCities.QC : objProvCities.ON;

            $(fsProvinceItems).empty();
            $.each(selectedProvCities, function (i, item) {
                let li = $("<li><a></a></li>");
                $(fsProvinceItems).append(li);
                $("a", li).text(item);
                $("a", li).attr("href", '#');
            });

            $(fsSearchProvinceButton).click();
            $(fsOpenCity).text($(fsOpenCity).attr('data-initial-text'));
            $(fsCityHidden).val('');

            $(fsCityContainer + ' li a[href=#]').click(function (e) {
                e.preventDefault();
                let city = $(this).text();
                $(fsCityHidden).val(city);
                let $searchCity = $(fsSearchCityButton);
                $searchCity.text(city);
                $searchCity.click();
                let imgIcon = $("<img src=\"/images/main/actions/toggle-down.svg\" alt=\"\" />");
                $searchCity.append(imgIcon);
                $(fsPostalCode).val('');
                if ($(fsFindButton).length) {
                    $(fsFindButton).prop('disabled', false);
                }
            });
        });

        $(fsCityContainer + ' li a[href=#]').click(function (e) {
            e.preventDefault();
            let city = $(this).text();
            $(fsCityHidden).val(city);
            let $searchCity = $(fsSearchCityButton);
            $searchCity.text(city);
            $searchCity.click();
        });

        // For Discount, only one banner is in DOM. Trigger click to fill the cities lists.
        let $provincesInFindStore = $(fsSearchProvince + ' li a[href=#]');
        if ($provincesInFindStore.length === 1) {
            $provincesInFindStore.trigger('click');
        }
    }

    return {
        bindFindStore: _bindFindStore
    };
}();

function callStoresData() {
    $.ajax({
        url: findShoppingStoreUrl,
        type: 'GET',
        contentType: 'application/json',
        dataType: 'html',
        cache: false,
        success: function (data, code, jqXHR) {
            $('#storeSelectorContainer').html(data);
            $('.store-selector.rightPanel').removeClass('in-progress');
            $("#storeSelectorContainer #postalCode").mask('S0S 0S0');
            $("#storeSelectorContainer .find-btn").prop('disabled', true);

            if (TINK.matchMediaMobile()) {
                $("#storeSelectorContainer .fs-search-province").addClass('hide');
                $("#storeSelectorContainer .fs-search-city").addClass('hide');
                $(".mobile-open-selection").addClass('hide');
            }
            initStoreSlider();
        },
        error: function (jqXHR) {
            TINK.redirectIfConflict(jqXHR);
        }
    });
}

function initStoreSlider() {
    const fsContainerId = '#storeSelectorContainer';
    const fsBoxesShops = fsContainerId + ' .fs--boxes-shops';
    const fssForm = fsContainerId + ' #fssForm';
    const fsSearchProvince = fsContainerId + ' .fs-search-province';
    const fsSearchCity = fsContainerId + ' .fs-search-city';
    const fsFindButton = fsContainerId + ' .find-btn';
    const fsPostalCode = fsContainerId + ' #postalCode';

    $(fsPostalCode).on('keyup', function () {
        let postalCodeLength = $(fsPostalCode).val().length;
        if (postalCodeLength === 7) {
            $(fsFindButton).prop('disabled', false);
        } else {
            $(fsFindButton).prop('disabled', true);
        }
    });

    $('.mobile-city-link').bind('click', function () {
        if ($(fsSearchProvince).hasClass('hide')) {
            $(fsSearchProvince).removeClass('hide');
            $(fsSearchCity).removeClass('hide');
            $(".mobile-open-selection").removeClass('hide');
            $(".mobile-city-link").addClass('active');
        } else {
            $(fsSearchProvince).addClass('hide');
            $(fsSearchCity).addClass('hide');
            $(".mobile-open-selection").addClass('hide');
            $(".mobile-city-link").removeClass('active');
        }
    });

    $('.ss--footer .setMyStoreButton').off('click').on('click', onClickConfirmMyShoppingStore);
    var form = $(fssForm);
    var sectionInProgress = $('.internal.vitrine');
    form.submit(function (e) {
        e.preventDefault();
        $('#error-summary').html('');
        sectionInProgress.addClass('in-progress relative');
        $.ajax({
            type: form.attr('method'),
            url: form.attr('action'),
            data: form.serialize(),
            success: function (data) {
                sectionInProgress.removeClass('in-progress relative');
                var html = $(data);
                form.find('input').blur();

                $('#error-summary').html(html.find('#error-summary-replacement').html());
                if (html.find('#map-results-replacement').length > 0) {
                    $(fsBoxesShops).css('visibility', 'visible');
                    $(fsBoxesShops).replaceWith(html.find('#map-results-replacement')[0].outerHTML);
                    $('.fs--box-shop.radio--standard').click(function () {
                        let storeId = $(this)[0].getAttribute("data-storeid");
                        $('.ss--footer .setMyStoreButton')[0].setAttribute("data-storeid", storeId);
                        $('.ss--footer .setMyStoreButton').prop('disabled', false);
                    });
                } else {
                    $(fsBoxesShops).css('visibility', 'hidden');
                    $(fsBoxesShops).hide();
                }
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    sectionInProgress.removeClass('in-progress relative');
                }
            }
        });
    });

    FindStoreHelper.bindFindStore(fsContainerId);
}

$(document).ready(function () {
    // open store selector only if no cart started
    if (typeof isCartAvailable !== 'undefined' && !isCartAvailable) {
        $('.sd--address-icon-cta-wrapper .openStoreLocator').addClass('hide');
        $('.sd--address-icon-cta-wrapper .setMyStoreButton').removeClass('hide');
    } else {
        $('.sd--address-icon-cta-wrapper .openStoreLocator').removeClass('hide');
        $('.sd--address-icon-cta-wrapper .setMyStoreButton').addClass('hide');
    }

    $('.user__shop span .modal-store-selector').click(function () {
        openSlider();
    });

    $('.set-fav-store .modal-store-selector').click(function () {
        openSlider();
    });

    $('#content-flyer .modal-store-selector').click(function () {
        openSlider();
    });

    function openSlider() {
        $(".ss--footer .setMyStoreButton").prop('disabled', true);
        $('.store-selector.rightPanel').addClass('in-progress');
        callStoresData();
    }
});